import { SecurityCard, TwoFactorAuthModal } from "@housebets/housebets-x-package";
import React from "react";
import { useIntl } from "react-intl";
import { useGTMEvents } from "app/hooks/useGTMEvents";
import { useTwoAuthVerificationData } from "./hooks/useTwoAuthVerificationData";
import { TwoFactorAuthForm } from "../../../forms";
import {useAppSelector} from "hooks/useAppSelector";

export const TwoAuthVerification: React.FC = () => {
    const {
        isModalOpen,
        setIsModalOpen,
        setIsVerified,
        verified,
    } = useTwoAuthVerificationData();

    const { modal } = useGTMEvents();
    const { formatMessage: t } = useIntl();

    const userData = useAppSelector((state) => state.user.user);
    const is2faEnabled = verified || userData?.googleAutoCryptoState !== 0;

    return (
        <>
            <SecurityCard
                title={t({ id: "TwoAuth.title" })}
                text={t({ id: "TwoAuth.description" })}
                onClick={() => setIsModalOpen(true)}
                submitButtonText={t({ id: "TwoAuth.button.submit" })}
                verifiedButtonText={t({ id: "TwoAuth.button.verified" })}
                verified={is2faEnabled}
                type="switch"
            />
            <TwoFactorAuthModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                afterOpenModal={() => {
                    modal.show("two_factor_authentication");
                }}
                onAfterClose={() => {
                    modal.close("two_factor_authentication");
                }}
            >
                <TwoFactorAuthForm
                    verified={is2faEnabled}
                    setIsVerified={setIsVerified}
                    onSubmit={() => {
                        setIsModalOpen(false);
                    }}
                />
            </TwoFactorAuthModal>
        </>
    );
};

TwoAuthVerification.displayName = "TwoAuthVerification";
